import { getProvider, getWeb3 } from ".";
import config, { CHAIN } from "../../config/config";

import MafiaInJailABI from "../../abis/MafiaInJail.json";
import { ChainType } from "../../constants/enum/enum";

export const getMafiaInJailContract = (provider = false) => {
  const web3 = provider ? getProvider() : getWeb3();
  const contractAddress = config.inJailAddress;
  const MafiaInJailContract = new web3.eth.Contract(
    MafiaInJailABI,
    contractAddress
  );
  return MafiaInJailContract;
};

export const isInJail = async (address: string) => {
  if (CHAIN === ChainType.BNB) return false;

  const MafiaInJailContract = getMafiaInJailContract();

  const isInJail = await MafiaInJailContract.methods
    .isInPunishment(address)
    .call();

  return Boolean(isInJail);
};
